import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  TextField,
  withStyles,
  InputAdornment,
  LinearProgress,
  FormHelperText,
} from '@material-ui/core'
import { MapMarker } from 'mdi-material-ui'
import { handleDefaultFieldChange } from 'actions/contacts/addOrEdit'
import { createOrUpdateContact } from 'actions/contacts'
import { withRouter } from 'react-router-dom'
import language from 'utils/vast-languagepack'

export default withRouter(
  connect(
    state => ({
      location: state.addOrEditContact.fields.location.value,
      error: Object.keys(state.addOrEditContact.fields.location.error).join(', '),
    }),
    dispatch =>
      bindActionCreators(
        { handleDefaultFieldChange, createOrUpdateContact },
        dispatch,
      ),
  )(
    withStyles(theme => {
      const light = theme.palette.type === 'light'
      const bottomLineColor = light
        ? 'rgba(0, 0, 0, 0.42)'
        : 'rgba(255, 255, 255, 0.7)'

      return {
        underline: {
          '&:before': {
            '@media (hover: none)': {
              borderBottom: `1px solid ${bottomLineColor}`,
            },
            borderBottom: 0,
          },
          '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: `1px solid ${bottomLineColor}`,
          },
        },
        focused: {},
        disabled: {},
        error: {},
        icon: { color: theme.palette.secondary.main },
      }
    })(
      class Location extends Component {
        state = {
          typing: false,
        }

        handleChange = e => {
          clearTimeout(this.timeout)
          this.props.handleDefaultFieldChange('location', e.target.value)
          this.setState({ typing: true })
          this.timeout = setTimeout(() => {
            this.props.createOrUpdateContact().then(payload => {
              if (
                this.props.history.location.pathname.slice(0, 13) ===
                '/contacts/new'
              ) {
                this.props.history.replace(`/contacts/${payload.id}`)
              }
            },
            err => {
              return
            })
            this.setState({ typing: false })
          }, 500)
        }

        render() {
          const { classes, location, error } = this.props

          return (
            <div>
              <TextField
                onChange={this.handleChange}
                value={location}
                fullWidth
                placeholder={language.contacts.add.location}
                InputProps={{
                  classes: { underline: classes.underline },
                  startAdornment: (
                    <InputAdornment position="start">
                      <MapMarker className={classes.icon} />
                    </InputAdornment>
                  ),
                }}
              />
              {this.state.typing ? <LinearProgress color="secondary" /> : null}
              <FormHelperText error={error}>{error}</FormHelperText>
            </div>
          )
        }
      },
    ),
  ),
)
